// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Button from "components/base/Button";

// #####################################################

export const StyledModalItem = styled(Button)(() => {
	return css`
		background: transparent;
		padding: 0.5rem 1rem;
		display: flex;
		align-items: center;
		width: 100%;
		justify-content: flex-start;
		text-align: left;
		line-height: 1.5;
		justify-content: space-between;
		color: ${({ theme: { colors } }) => colors.black};

		${({ alwaysLight, disabled }) =>
			!disabled
				? css`
						color: ${({ theme: { colors } }) =>
							alwaysLight ? colors.blackAlways : colors.black};};
						&:hover {
							background-color: ${({ theme: { colors } }) =>
								alwaysLight
									? colors.menuItemHoverAlwaysLight
									: colors.menuItemHover};
						}
						&:active {
							background-color: ${({ theme: { colors } }) =>
								alwaysLight
									? colors.menuItemActiveAlwaysLight
									: colors.menuItemActive};
						}
				  `
				: css`
						color: ${({ theme: { colors } }) => colors.grey};
				  `}

		${({ withIcon }) =>
			withIcon &&
			css`
				justify-content: space-between;
			`}

		${({ isSelected }) =>
			isSelected &&
			css`
				font-weight: bold;
			`}

		${({ $isRegister }) =>
			$isRegister &&
			css`
				font-size: 1.1rem;
			`}
	`;
});

// #####################################################
